import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="agreement-scroll"
export default class extends Controller {
  static targets = ["content", "checkbox", "continueButton", "scrollMessage"]

  connect() {
    // Get session storage key based on invitation token
    const token = window.location.pathname.split("/")[2]
    this.storageKey = `agreement_acknowledged_${token}`

    // Check if user has already acknowledged this agreement in this session
    const hasAcknowledged = sessionStorage.getItem(this.storageKey) === "true"

    if (hasAcknowledged) {
      // User has already read and acknowledged - enable everything immediately
      this.enableCheckbox()
      this.checkboxTarget.checked = true
      this.toggleButton()
    } else {
      // First time viewing - require scroll to bottom
      this.checkScroll()
    }
  }

  checkScroll() {
    const content = this.contentTarget
    const scrolledToBottom = Math.abs(content.scrollHeight - content.scrollTop - content.clientHeight) < 10

    if (scrolledToBottom) {
      this.enableCheckbox()
    }
  }

  enableCheckbox() {
    // Enable the checkbox
    this.checkboxTarget.disabled = false

    // Hide the scroll message
    if (this.hasScrollMessageTarget) {
      this.scrollMessageTarget.classList.add("hidden")
    }

    // Add a visual indicator that the checkbox is now available
    const label = this.checkboxTarget.closest("div").querySelector("label")
    if (label) {
      label.classList.add("text-primary-600", "dark:text-primary-400")
      label.classList.remove("text-gray-900", "dark:text-gray-300")
    }
  }

  toggleButton() {
    // Enable/disable continue button based on checkbox state
    this.continueButtonTarget.disabled = !this.checkboxTarget.checked

    // Store acknowledgment state when checkbox is checked
    if (this.checkboxTarget.checked) {
      sessionStorage.setItem(this.storageKey, "true")
    }
  }

  continue() {
    // Mark as acknowledged before navigating
    sessionStorage.setItem(this.storageKey, "true")

    // Redirect to signing page
    const token = window.location.pathname.split("/")[2]
    window.location.href = `/fund_invitations/${token}/agreement/sign`
  }
}
